<template>
  <Modal v-model="isShow" width="75%" :closable="false" :mask-closable="false" styles="overflow-x: hidden;">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">客户分析报告</div>
      <a class="ivu-modal-pdf " @click="downPdf"><i class="ivu-icon ivu-icon-md-download"></i></a>
      <a class="ivu-modal-print" @click="printIt"><i class="ivu-icon ivu-icon-ios-print"></i></a>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <reportContent ref="reportContent"></reportContent>
  </Modal>
</template>

<script>

import reportContent from './report-content'
import { download } from '@/libs/api.request'
export default {
  name: 'custominfo-info',
  components: { reportContent },
  data () {
    return {
      form: {},
      barData: {},
      isShow: false,
      type: 'add',
      disable: true,
      showRemoveFile: false
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
      this.dataMap = null
      this.$refs.reportContent.loadData(data.id)
    },
    closeModel () {
      this.isShow = false
    },
    printIt () {
      this.$refs.reportContent.printIt()
    },
    downPdf () {
      download('api/tradeUploadError/download', { id: this.form.id })
    }
  },
  mounted: function () {
  }
}
</script>
<style>
.ivu-modal-print {
  margin: 20px 60px 10px 40px;
  z-index: 1;
  font-size: 14px;
  position: absolute;
  right: 8px;
  top: 8px;
  overflow: hidden;
  cursor: pointer;
}

.ivu-modal-pdf {
  margin: 20px 60px 10px 40px;
  z-index: 1;
  font-size: 14px;
  position: absolute;
  right: 44px;
  top: 8px;
  overflow: hidden;
  cursor: pointer;
}
/* 添加 AI 画像按钮样式 */
.ivu-modal-ai-portrait {
  margin: 20px 60px 10px 40px;
  z-index: 1;
  font-size: 14px;
  position: absolute;
  right: 80px;
  top: 8px;
  overflow: hidden;
  cursor: pointer;
}
</style>
